import _ from "lodash";
import Box from '@mui/material/Box';
import {Card, CardContent} from "@mui/material";
import Grid from "@mui/material/Grid";

import PatientFilters, {SortButton} from './PatientFilters';
import MessageUserButton from '../messages/MessageUserButton';
import SchedulePatientButton from './SchedulePatientButton';
import PatientTabFilters from "./PatientTabFilters";
import PatientTable from "./PatientTable";
import CustomAccordionStatusFilter from "../common/CustomAccordionStatusFilter";
import {getPatientStatusOptions} from "./PatientStatusFilter";


const ListPatientsScreen = props => {
    const {patients} = props;
    const rows = patients.map(p => ({
      data: p,
      buttons: [
        <SchedulePatientButton patient={p} iconOnly fill={'var(--primary)'}/>,
        <MessageUserButton patient={p} iconOnly fill={'var(--primary)'}/>,
      ]
    }));
    const currentStatus = props.filters?.patient_status ?? 'Filter Patients';
    const {Icon, color} = getPatientStatusOptions(_.camelCase(currentStatus));
    return (
      <Box marginTop='12px'>
        <PatientFilters counts={props.counts} filters={props.filters} onFilterChange={props.onFilterChange}/>

        <Card className="list-session__card drop-shadow">
          <CardContent sx={{padding: {xs: '0', sm: '12px 24px'}}}>
            <Box sx={{  display: {'xs': 'block', 'lg': 'none'} }}>
              <CustomAccordionStatusFilter
                summaryColor={color}
                SummaryIcon={props.filters?.patient_status && Icon}
                iconUrl="/images/logo-180px.png"
                summaryName={currentStatus}
                count={props.counts[_.camelCase(props.filters?.patient_status ?? 'All')]}
                DetailComponent={() => <PatientTabFilters {...props}/>}
              />
            </Box>
            <Grid container sx={{width: '100%', display: {'xs': 'flex', 'sm': 'none'}, justifyContent: 'flex-end', padding: "0 16px" }}>
              <Grid item xs="auto">
                <SortButton
                  sort={props.filters.sort}
                  onChange={sort => props.onFilterChange({...props.filters, sort})}
                />
              </Grid>
            </Grid>
            <Box sx={{width: '100%', display: {xs: 'none', lg: 'block'}}}>
              <PatientTabFilters {...props}/>
            </Box>
            <PatientTable {...props} rows={rows}/>
          </CardContent>
        </Card>
      </Box>
    );
  }
;

ListPatientsScreen.propTypes = {};

export default ListPatientsScreen;
